// extracted by mini-css-extract-plugin
export default {"textCell":"text_textCell__3LsEr","skeleton":"text_skeleton__dW8CZ"};